import { Galleria } from 'primereact/galleria';
import { Image } from 'primereact/image';
import { useEffect, useState } from 'react';
import { PhotoService } from '../photo/PhotoService';
import { useNavigate } from 'react-router';
import { Button } from 'primereact/button';
import  pkgjson  from '../../package.json';

type PhotoItem = {
	itemImageSrc: string,
	thumbnailImageSrc: string|undefined,
	alt: string,
	// title: string,
}
function PhotoPage() 
{
	const [images, setImages] = useState<PhotoItem[]>([]);
	const [activeIndex, setActiveIndex] = useState(0)
	const navigate = useNavigate();
	
	let baseUrl = '';
	try {
		baseUrl = pkgjson.homepage;
	} catch (error) {
	}
	
	const itemTemplate = (item: PhotoItem) => {
		if (window.innerWidth > 1000 ) 
        	return <Image src={baseUrl + item.itemImageSrc} alt="Image" height='600vmax'/>;
		else
			return <Image src={baseUrl + item.itemImageSrc} alt="Image" width='300vmax'/>;
		}
		// <Image src={item.itemImageSrc} alt="Image" height='600vh'/>;
		// <img src={item.itemImageSrc} alt={item.alt} style={{ width: '100%', display: 'block' }} />;
    // const thumbnailTemplate = (item) => {
    //     return <img src={item.thumbnailImageSrc} alt={item.alt} style={{ display: 'block' }} />;
    // }
    useEffect(() => {
		PhotoService.getImages().then(data => setImages(data));
	}, []);
	const next = () => {
        setActiveIndex(prevState => (prevState === images.length - 1) ? 0 : prevState + 1)
    }

    const prev = () => {
        setActiveIndex((prevState) => (prevState === 0 ? 0 : prevState - 1));
    };
	return (
	<div className='photo_content'>
		<div className='flex flex-row align-items-center pr-2'>
			<i className="pi pi-times-circle m-2" style={{ fontSize: '1.5rem', cursor: 'pointer' }}
				onClick={() => navigate("/")}
			></i>
			<div className="flex-grow-1 text-center">Few pictures (taken with Canon EOS 100D). Open image in new tab to see the full picture.</div>
		    <div >
                <Button icon="pi pi-chevron-left" outlined onClick={prev} className="ml-2"/>
                <Button icon="pi pi-chevron-right" outlined onClick={next} className="ml-2" />
            </div>
		</div>
		<Galleria value={images} numVisible={5} circular style={{margin: 'auto' }} 
			activeIndex={activeIndex}
			showThumbnails={false} item={itemTemplate} 
			onItemChange={(e) => setActiveIndex(e.index)}
			// thumbnail={thumbnailTemplate}
		/>
	</div>
	);
}

export default PhotoPage;